<template>
  <div>
    <div class="page-head">
      <div>
        <h2>员工顾问</h2>
        <p>维护后台员工和顾问账号，新增账号默认密码为 123456。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增员工</el-button>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="账号/姓名/手机号/员工码" clearable /></el-form-item>
        <el-form-item label="账号状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="正常" value="active" />
            <el-option label="停用" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="username" label="登录账号" width="150" />
        <el-table-column prop="name" label="姓名" width="140" />
        <el-table-column prop="phone" label="手机号" width="140" />
        <el-table-column prop="staff_code" label="员工码" width="160" />
        <el-table-column prop="status" label="账号状态" width="110"><template slot-scope="{ row }"><status-tag :value="row.status" /></template></el-table-column>
        <el-table-column label="操作" width="170" fixed="right"><template slot-scope="{ row }"><el-button type="text" @click="openEdit(row)">编辑</el-button><el-button type="text" @click="openAttributions(row)">归因订单</el-button></template></el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增员工' : '编辑员工'" :visible.sync="drawerVisible" width="520px" destroy-on-close>
      <el-form ref="form" class="drawer-form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="登录账号" prop="username"><el-input v-model="form.username" :disabled="drawerMode === 'edit'" /></el-form-item>
        <el-form-item label="姓名" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="手机号"><el-input v-model="form.phone" /></el-form-item>
        <el-form-item label="角色ID"><el-input-number v-model="form.role_id" :min="0" /></el-form-item>
        <el-form-item label="员工码"><el-input v-model="form.staff_code" /></el-form-item>
        <el-form-item label="账号状态">
          <el-select v-model="form.status">
            <el-option label="正常" value="active" />
            <el-option label="停用" value="inactive" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存员工</el-button>
      </div>
    </el-dialog>

    <el-dialog title="员工归因订单" :visible.sync="attributionVisible" width="880px">
      <div class="attribution-summary">
        <span>员工：{{ activeStaff.name || '-' }}（{{ activeStaff.staff_code || '未设置员工码' }}）</span>
        <span>归因订单 {{ attributionSummary.order_total || 0 }} 笔</span>
        <span>成交 {{ attributionSummary.paid_order_total || 0 }} 笔 / ¥{{ money(attributionSummary.paid_amount) }}</span>
      </div>
      <el-table v-loading="attributionLoading" :data="attributionOrders" border size="small">
        <el-table-column prop="order_no" label="订单号" min-width="185" />
        <el-table-column prop="user_nickname" label="用户" width="120" />
        <el-table-column prop="amount" label="金额" width="100" />
        <el-table-column prop="payment_status" label="支付状态" width="110"><template slot-scope="{ row }"><status-tag :value="row.payment_status" /></template></el-table-column>
        <el-table-column prop="recommender_name" label="协同推荐官" width="130" />
        <el-table-column prop="attribution_source" label="归因来源" min-width="170" />
        <el-table-column label="下单时间" width="180"><template slot-scope="{ row }">{{ row.created_at | dateTime }}</template></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import StatusTag from "../components/StatusTag.vue";
import { createResource, listResource, updateResource } from "../api/resources";
import http from "../api/http";

export default {
  name: "StaffManage",
  components: { PagedTable, StatusTag },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      form: this.emptyForm(),
      attributionVisible: false,
      attributionLoading: false,
      activeStaff: {},
      attributionSummary: {},
      attributionOrders: [],
      rules: {
        username: [{ required: true, message: "请填写登录账号", trigger: "blur" }],
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    emptyForm() {
      return { username: "", name: "", phone: "", role_id: 0, staff_code: "", status: "active" };
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("staff", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = this.emptyForm();
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = { ...this.emptyForm(), ...row, role_id: Number(row.role_id || 0) };
      this.drawerVisible = true;
    },
    async openAttributions(row) {
      this.activeStaff = { ...row };
      this.attributionSummary = {};
      this.attributionOrders = [];
      this.attributionVisible = true;
      this.attributionLoading = true;
      try {
        const res = await http.get(`/staff/${row.id}/attributions`);
        const data = res.data || {};
        this.attributionSummary = data.summary || {};
        this.attributionOrders = data.orders || [];
      } finally {
        this.attributionLoading = false;
      }
    },
    money(value) {
      return Number(value || 0).toFixed(2);
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          if (this.drawerMode === "create") await createResource("staff", this.form);
          else await updateResource("staff", this.form.id, this.form);
          this.$message.success("员工账号已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.attribution-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  color: #303133;
}
</style>
